import messageIqSignup from "@/services/messageIqSignup";

// New, additive Vuex module for the pay-first "Message IQ" signup flow.
// Entirely separate from src/store/modules/registration.js and
// src/store/modules/SmartRamp/productRegistration.js - do not merge.
export default {
    namespaced: true,
    state: {
        plan: null,
        signupToken: null,
        signupTokenExpiresAt: null,
        paymentComplete: false,
        email: null,
        // Carried over from the payment step's billing form so the account step
        // doesn't ask the lead to re-type their company name/address.
        billingInfo: null
    },
    mutations: {
        SET_PLAN(state, plan) {
            state.plan = plan;
        },
        SET_SIGNUP_TOKEN(state, { signupToken, expiresAt }) {
            state.signupToken = signupToken;
            state.signupTokenExpiresAt = expiresAt;
        },
        SET_PAYMENT_COMPLETE(state, paymentComplete) {
            state.paymentComplete = paymentComplete;
        },
        SET_EMAIL(state, email) {
            state.email = email;
        },
        SET_BILLING_INFO(state, billingInfo) {
            state.billingInfo = billingInfo;
        }
    },
    actions: {
        async fetchPlan({ commit }, planId) {
            const response = await messageIqSignup.getPlan(planId);
            commit("SET_PLAN", response.data);
            return response.data;
        },

        async submitPayment({ commit }, payload) {
            const response = await messageIqSignup.submitPayment(payload);
            const { signupToken, expiresAt } = response.data;
            commit("SET_SIGNUP_TOKEN", { signupToken, expiresAt });
            commit("SET_PAYMENT_COMPLETE", true);
            commit("SET_EMAIL", payload.email);
            commit("SET_BILLING_INFO", {
                companyName: payload.companyName,
                firstName: payload.firstName,
                lastName: payload.lastName,
                address: payload.address,
                address2: payload.address2,
                city: payload.city,
                state: payload.state,
                zip: payload.zip
            });
            return response.data;
        },

        async completeSignup({ state, commit }, payload) {
            const response = await messageIqSignup.completeSignup(state.signupToken, payload);
            commit("SET_EMAIL", response.data.email);
            return response.data;
        }
    },
    getters: {
        getPlan: state => state.plan,
        getSignupToken: state => state.signupToken,
        getSignupTokenExpiresAt: state => state.signupTokenExpiresAt,
        getPaymentComplete: state => state.paymentComplete,
        getEmail: state => state.email,
        getBillingInfo: state => state.billingInfo
    }
};
